import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {GetLatestValue} from "@Common/react/get-latest-value";
import {PROGRAM_TYPE}   from "@Xpresso/routes/common/logic/program";

export const EnsureItemAddedToCart = ({next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("cart"),
    ["getLatestCart", ({cart}, next) => GetLatestValue({
        value: cart.value,
        condition: () => !cart.loading,
        next,
    })],
    ({apis, cart: rootCart, getLatestCart}) => rootNext(async ({item}) => {

        const cart1 = await (async () => {
            if (item?.programType === PROGRAM_TYPE.SCHEDULED_CAMPAIGNS) {
                return await apis.next.cart.getCartByItem(item?.itemId);
            } else {
                return await getLatestCart();
            }
        })();

        const cart = await (async () => {
            if (cart1?.cartId) {
                return cart1;
            } else {
                const cartType = item?.programType === PROGRAM_TYPE.SCHEDULED_CAMPAIGNS ? "AUTO" : "MAIN";
                return await apis.next.cart.createCart(cartType);
            }
        })();

        if (cart?.result === 'failure') {
            return {"cartId": '', "result": "failure", "msg": cart?.errors?.msg};
        }

        if (item && cart.items?.find((i) => i.itemId === item.itemId) == null) {
            const savedCart = await apis.next.cart.addItemsToCart({cartId: cart.cartId, itemIds: [item.itemId]});
            if (savedCart.result === 'failure' ) {
                return {"cartId": cart.cartId, "result": "failure", "msg": savedCart.errors.msg};
            }
            rootCart.onChange(savedCart);
        } else if (!cart1) {
            rootCart.onChange(cart);
        }

        return {cartId: cart.cartId};
    }),
);



/*const saveOrder = async (item, rootCart, user, apis) => {
    const cartId = await (async () => {
        if (cart) {
            return cart.cartId;
        } else {
            const cart1 = await apis.next.cart.createCart();
            return cart1.cartId;
        }
    })();

    const cart = await user.getCart();
    if (cart?.value?.items.find((i) => i.itemId === item.itemId) == null) {
        await apis.next.cart.addItemsToCart({cartId, itemIds: [item.itemId]});
        await rootCart.reload();
    }

    return {cartId};
};*/

/*const saveOrder = async (item, {query, cart, apis}) => {
    const cartId = await (async () => {
        if (query?.cart_id) {
            return query.cart_id;
        } else if (cart.value) {
            return cart.value.cartId;
        } else {
            const cart1 = await apis.next.cart.createCart();
            return cart1.cartId;
        }
    })();

    if (cart.value?.items.find((i) => i.itemId === item.itemId) == null) {
        await apis.next.cart.addItemsToCart({cartId, itemIds: [item.itemId]});
        await cart.reload();
    }

    return {cartId};
};*/